(function (host) {
  'use strict';
  const vendors = {
    '나이키':['Nike','耐克'], '나이키 백팩':['Nike backpack'], '뉴발란스':['New Balance','NB','뉴발','新百伦','新百倫'],
    '아디다스':['Adidas','阿迪达斯','阿迪達斯'], '컨버스':['Converse','匡威'], '아식스':['ASICS','亚瑟士'],
    '오니츠카타이거':['Onitsuka Tiger','鬼冢虎'], '호카':['HOKA'], '크록스':['Crocs','卡骆驰'], '푸마':['Puma','彪马'],
    '살로몬':['Salomon','萨洛蒙'], '노스페이스':['The North Face','North Face','北面'], '버켄스탁':['Birkenstock','勃肯'],
    '스투시':['Stussy','斯图西'], '알로 요가':['Alo Yoga','Alo'], '어그':['UGG'], '온 러닝':['On Running'],
    '잔스포츠':['Jansport'], '킨':['KEEN'], '팀버랜드':['Timberland','添柏岚'], '미하라 야스히로':['Mihara Yasuhiro'],
    '폴로 랄프 로렌 볼캡':['Polo Ralph Lauren','Polo'], 'MLB':['엠엘비']
  };
  const escape = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const compact = value => String(value || '').toUpperCase().replace(/[\s-]/g, '');
  const syntax = value => /["():<>\[\]{}|*]|(?:^|\s)[+-]\S|\b(?:AND|OR|NOT)\b/i.test(value);
  function entries(aliases) {
    const list = Object.entries(vendors).flatMap(([name, values]) => [name, ...values].map(value => [value, name]));
    String(aliases || '').split('\n').forEach(line => {
      const pair = line.split('=').map(x => x.trim());
      if (pair.length !== 2 || !pair[0] || !pair[1]) return;
      const canonical = list.find(([value]) => value.toLowerCase() === pair[1].toLowerCase());
      if (canonical) list.push([pair[0], canonical[1]]);
    });
    return list.sort((a,b) => b[0].length - a[0].length);
  }
  function numericModelMatches(query, models = []) {
    let token = String(query || '').trim().toUpperCase();
    const vendor = Object.keys(vendors).sort((a,b) => b.length-a.length).find(name => token.startsWith(name.toUpperCase()+' '));
    if (vendor) token = token.slice(vendor.length).trim();
    if (!/^\d{4,}(?:[\s-]*\d{2,})?$/.test(token)) return [];
    return models.filter(item => {
      const model = String(typeof item === 'string' ? item : item.model || '').toUpperCase();
      const numeric = model.replace(/^[A-Z]+-?/, '');
      return (!vendor || item.vendor === vendor) && /^\d{4,}(?:-[A-Z0-9]+)*$/.test(numeric)
        && (numeric.split('-')[0] === token || compact(numeric) === compact(token));
    });
  }
  function normalize(query, aliases, models = []) {
    let value = String(query || '').trim();
    if (syntax(value)) return value;
    value = value.replace(/(^|\s)p[\s-]*6000(?=\s|$)/gi, (_, prefix) => prefix + 'P-6000');
    const found = new Set();
    models.forEach(item => {
      const model = String(typeof item === 'string' ? item : item.model || '').toUpperCase();
      if (!model || found.has(model)) return;
      found.add(model);
      const pieces = model.split('-');
      const expression = pieces.map(escape).join('[\\s-]*');
      value = value.replace(new RegExp('(^|\\s)' + expression + '(?=\\s|$)', 'gi'), (_, prefix) => prefix + model);
    });
    value = value.replace(/\b([a-z0-9]{2,}-[a-z0-9]{2,})\b/gi, part => part.length >= 6 && /\d/.test(part) ? part.toUpperCase() : part);
    for (const [alias, vendor] of entries(aliases)) {
      const pattern = new RegExp('(^|\\s)' + escape(alias) + '(?=\\s|$|\\d+(?:\\s|$))', 'gi');
      value = value.replace(pattern, (match, prefix, offset, source) => prefix + vendor + (/\d/.test(source[offset + match.length] || '') ? ' ' : ''));
    }
    value = value.replace(/\s+/g, ' ');
    const matches = numericModelMatches(value, models);
    if (matches.length) {
      const token = value.match(/\d{4,}(?:[\s-]*\d{2,})?$/)?.[0];
      const canonical = new Set(matches.map(item => {
        const model = String(typeof item === 'string' ? item : item.model).toUpperCase();
        return compact(model.replace(/^[A-Z]+-?/, '')) === compact(token)
          ? model : model.match(/^[A-Z]+-?\d{4,}/)?.[0];
      }));
      if (canonical.size === 1 && [...canonical][0]) value = value.slice(0, -token.length) + [...canonical][0];
    }
    return value;
  }
  function brandFor(query, aliases) {
    if (syntax(String(query || ''))) return null;
    let remaining = normalize(query, aliases);
    const found = new Set();
    // Consume the longest vendor first so Nike backpack is not also Nike.
    for (const vendor of Object.keys(vendors).sort((a,b) => b.length-a.length)) {
      const pattern = new RegExp('(^|\\s)' + escape(vendor) + '(?=\\s|$)', 'gi');
      remaining = remaining.replace(pattern, (_, prefix) => {found.add(vendor);return prefix;});
    }
    return found.size === 1 ? [...found][0] : null;
  }
  function modelMatches(query, models = []) {
    const words = String(query || '').replace(/\bAND\b/g, ' ').trim();
    return models.filter(item => {
      const model = String(item.model || '').toUpperCase();
      if (!model) return false;
      const re = new RegExp('(^|\\s)' + model.split('-').map(escape).join('[\\s-]*') + '(?=\\s|$)', 'i');
      return re.test(words);
    });
  }
  function exactProducts(query, aliases, models = []) {
    const numeric = numericModelMatches(normalize(query,aliases),models);
    if(numeric.length)return numeric;
    const normalized=normalize(query,aliases,models);
    if(syntax(normalized.replace(/\bAND\b/g,'')))return [];
    return modelMatches(normalized,models).filter(item=>{
      const remaining=normalized.replace(item.model,'').replace(/\bAND\b/g,'').trim();
      return !remaining || remaining===item.vendor;
    });
  }
  function passesFilters(product, search) {
    const params=new URLSearchParams(search), supported=['filter.p.vendor','filter.v.price.gte','filter.v.price.lte','filter.v.availability'];
    if([...params.keys()].some(key=>key.startsWith('filter.') && !supported.includes(key)))return null;
    const brands=params.getAll('filter.p.vendor');if(brands.length && !brands.includes(product.vendor))return false;
    const min=params.get('filter.v.price.gte')?.trim()?Number(params.get('filter.v.price.gte')):0;
    const max=params.get('filter.v.price.lte')?.trim()?Number(params.get('filter.v.price.lte')):Infinity;
    if(!Number.isFinite(min) || (!Number.isFinite(max) && max!==Infinity))return null;
    const availability=params.getAll('filter.v.availability');
    if(availability.some(value=>!['0','1'].includes(value)))return null;
    return (product.variants || []).some(variant=>variant.price/100>=min && variant.price/100<=max && (!availability.length || availability.includes(variant.available?'1':'0')));
  }
  function sortExactProducts(records, sort) {
    const field=sort?.startsWith('price-')?'price':sort?.startsWith('title-')?'title':sort?.startsWith('created-')?'createdAt':null;
    if(!field)return records.slice();
    const direction=sort.endsWith('-descending')?-1:1;
    return records.map((item,index)=>({item,index})).sort((a,b)=>{
      const first=a.item.data?.[field],second=b.item.data?.[field];
      const comparison=field==='title' && typeof first==='string' && typeof second==='string'?first.localeCompare(second,'ko-KR'):Number.isFinite(Number(first)) && Number.isFinite(Number(second))?Number(first)-Number(second):0;
      return comparison*direction || a.index-b.index;
    }).map(value=>value.item);
  }
  function rankProducts(products, query, models) {
    const exact = new Set(modelMatches(query, models).map(item => String(item.id)));
    return products.map((item, index) => ({item,index})).sort((a,b) => Number(exact.has(String(b.item.id))) - Number(exact.has(String(a.item.id))) || a.index - b.index).map(value => value.item);
  }
  function normalizeUrl(href, aliases, models) {
    const url = new URL(href);
    if (!/(?:^|\/)search\/?$/.test(url.pathname)) return null;
    const original = url.searchParams.get('q');
    if (!original) return null;
    const normalized = normalize(original, aliases, models);
    const brand = brandFor(original, aliases);
    const addBrand = brand && !url.searchParams.has('filter.p.vendor');
    if (normalized === original && !addBrand) return null;
    url.searchParams.set('q', normalized);
    if (addBrand) url.searchParams.set('filter.p.vendor', brand);
    if (!url.searchParams.has('_prem_q')) url.searchParams.set('_prem_q', original);
    return url.href;
  }
  function distance(a,b) {
    if (Math.abs(a.length-b.length)>1) return 2;
    const row=Array.from({length:b.length+1},(_,i)=>i);
    for(let i=1;i<=a.length;i++){let prev=row[0];row[0]=i;for(let j=1;j<=b.length;j++){const next=row[j];row[j]=Math.min(row[j]+1,row[j-1]+1,prev+(a[i-1]===b[j-1]?0:1));prev=next;}}
    return row[b.length];
  }
  function relatedProducts(query, aliases, models = []) {
    const normalized = normalize(query, aliases, models);
    if (syntax(normalized.replace(/\bAND\b/g,''))) return [];
    const token = normalized.split(/\s+(?:AND\s+)?/).find(word => /^[A-Z0-9]{4,}-[A-Z0-9]{2,}$/.test(word));
    const vendor = Object.keys(vendors).find(name => normalized === name || normalized.startsWith(name+' AND '));
    const related = models.filter(item => {
      if(token){const model=String(item.model||'').toUpperCase();return model!==token && (model.split('-')[0]===token.split('-')[0] || distance(compact(model),compact(token))<=1);}
      return vendor && item.vendor===vendor;
    });
    return related.sort((a,b)=>token ? distance(compact(a.model),compact(token))-distance(compact(b.model),compact(token)) : 0).slice(0,6);
  }
  function validateTerms(value) {
    if (!value || value.storeDomain !== 'y7qnzr-tm.myshopify.com' || !Number.isFinite(Date.parse(value.generatedAt)) || !Array.isArray(value.terms)) return null;
    if (value.terms.some(term => !term || typeof term.query !== 'string' || !term.query.trim() || !Number.isSafeInteger(term.count) || term.count < 0)) return null;
    return {storeDomain:value.storeDomain, generatedAt:value.generatedAt, terms:value.terms.slice(0,8).map(term=>({query:term.query,count:term.count}))};
  }
  function relatedStyles(pages, productIds) {
    const products = new Set(productIds.map(String)), seen = new Set();
    return pages.flat().filter(card => {
      if(!card.id || seen.has(String(card.id)) || !String(card.products || '').trim().split(/\s+/).some(id => products.has(id)))return false;
      seen.add(String(card.id));return true;
    });
  }
  const api = {normalize, brandFor, modelMatches, exactProducts, passesFilters, sortExactProducts, rankProducts, normalizeUrl, relatedProducts, validateTerms, relatedStyles};
  if(typeof module==='object' && module.exports) module.exports=api;
  else host.PremSearch=api;
})(typeof window==='object'?window:globalThis);
